<div
  class="CPI-container"
  [ngStyle]="{ 'background-color': headerCPI.isOpen ? 'white' : '#333' }"
>
  <button
    psUiButton
    class="header-div-h6 position-relative header-dropdown"
    [class.show]="!!headerCPI && headerCPI.isOpen"
    [ngClass]="{
      'dropdown-toggle': !(isMultiCountrySelected && !isDraftSaved)
    }"
    color="secondary"
    [disabled]="!cpi.length || loading"
    [psUiDropdownToggleFor]="headerCPI"
    (click)="propagateCpiDropdownVisibilityState(true)"
    psUiGtagEvent
    trackOn="click"
    action="cpi"
    category="Black_Bar"
    [params]="{ event_label: 'CPI Dropdown' }"
  >
    {{
      isMultiCountrySelected && !isDraftSaved
        ? Constants.AVERAGE_CPI
        : Constants.CPI
    }}
  </button>
  <ps-ui-dropdown
    #headerCPI="psUiDropdown"
    class="header-dropdown cpi-dropdown"
    (isClose)="updateSuppliersCPI($event)"
    [canClose]="!cpiRequireConfirmation"
  >
    <div
      class="row w-100 m-0 header overide_title"
      (click)="avoidClose($event)"
      *psUiConfigEnabled="'overridCmp'"
    >
      <div class="tooltip_override">
        <p>Price Override</p>
        <div class="setting-info" [hidden]="!updateCPI">
          <i class="fa fa-info-circle" aria-hidden="true"></i>
          <p>New CPI value will be applied when you close the dropdown.</p>
        </div>
      </div>
      <div class="d-flex align-items-center header_title">
        <div
          [ngClass]="{ global_title: loggedInAsServiceBuyer }"
          *ngIf="!isPurePriceApplied"
        >
          <ps-ui-slider
            *ngIf="!loggedInAsServiceBuyer"
            id="entryLinks"
            (selectedChange)="setEntryLinkFlag($event, 'global')"
            [selected]="globalPriceOveride"
            psUiHotjarEvent
            trackOn="change"
            eventName="Choose Your Supplier - Price Override"
          >
          </ps-ui-slider>
          <span class="selectBtn">Global Price Override</span>
        </div>
        <div
          class="manualCPI_header"
          *ngIf="!loggedInAsServiceBuyer && !isPurePriceApplied"
        >
          <label>CPI</label>
          <input
            type="text"
            #globalCpi
            class="form-control"
            step="0.01"
            min="0"
            id="override_cpi_value"
            [(ngModel)]="operatorOverrideCpi"
            (keypress)="numberOnly($event, true)"
            (input)="globalCpi.value = operatorOverrideCpi"
            (ngModelChange)="setGlobalOverrideCpi()"
            (click)="setEntryLinkFlag(true, 'global')"
            [ngClass]="{
              'input-error':
                globalOverrideCpi > this.maxCpiThreshold && globalPriceOveride
            }"
            psUiInputDecimalRestriction
          />
          <br />
        </div>
        <div
          class="serviceBuyer_message"
          *ngIf="loggedInAsServiceBuyer && !isPurePriceApplied"
        >
          Price override is disabled for WASP operator.
        </div>
        <div class="purePriceApplied_message" *ngIf="isPurePriceApplied">
          CPI Override and Selective Price Override are disable when the
          PurePrice is enabled
        </div>
      </div>
      <div class="d-flex align-items-center header_title">
        <div class="tooltip_override" *ngIf="!isPurePriceApplied">
          <div>
            <ps-ui-slider
              id="entryLinks"
              (selectedChange)="
                loggedInAsServiceBuyer
                  ? setSupplierOverrideFlag($event)
                  : setEntryLinkFlag($event, 'manual')
              "
              [(selected)]="
                loggedInAsServiceBuyer
                  ? manualSCPIOverrideEnabled
                  : selectivePriceOveride
              "
              psUiHotjarEvent
              trackOn="change"
              eventName="Choose Your Supplier - Selective Manual Override"
            >
            </ps-ui-slider>
            <span class="selectBtn">Selective Price Override</span>
          </div>
        </div>
      </div>
    </div>
    <ps-ui-cpi-override-confirmation
      *ngIf="
        (selectivePriceOveride || globalPriceOveride) &&
        cpiRequireConfirmation &&
        !cpiOverrideConfirmation.state
      "
      [type]="selectivePriceOveride ? 'selective' : 'global'"
      color="pink"
      (confirm)="onCpiOverrideConfirmation($event)"
      [surveyId]="this.surveyId"
      [newCpi]="operatorOverrideCpi"
    ></ps-ui-cpi-override-confirmation>
    <ps-ui-accordion [closeOthers]="true" [arrowToggleOnly]="false">
      <ps-ui-accordion-section [isExpanded]="true" class="dependency-accordion">
        <ng-template psUiAccordionTitle>Supplier Management</ng-template>
        <ng-template psUiAccordionContent>
          <div (click)="avoidClose($event)">
            <span *psUiConfigEnabled="'enableSupplierGrouping'">
              <ps-ui-select-dropdown
                class="d-block blend-dropdown"
                [dropdownItems]="blendSupplierGroups.listOfOptions"
                [field]="'config_name'"
                [loading]="loadingBlends"
                [enableSearch]="false"
                labelNone="-- Choose Supplier Blend --"
                [(ngModel)]="selectedBlend"
                (selectedItem)="selectBlend($event)"
                psUiHotjarEvent
                trackOn="click"
                eventName="Choose Your Supplier - Supplier Blends"
              >
              </ps-ui-select-dropdown>
            </span>
          </div>
          <div class="table-responsive newtable" (click)="avoidClose($event)">
            <table class="table table-borderless m-0">
              <thead>
                <tr>
                  <th>
                    <input
                      class="checkbox"
                      type="checkbox"
                      [checked]="isSuppliersListChecked"
                      (click)="selectAll($event)"
                    />
                  </th>
                  <th class="w-75" data-name="supplier" [psUiSortTable]="cpi">
                    <div
                      class="form-check form-check-inline m-0 supplier_title"
                    >
                      <label>Supplier</label>
                    </div>
                  </th>
                  <th
                    class="cpi"
                    data-name="cpi"
                    [psUiSortTable]="cpi"
                    *ngIf="selectivePriceOveride || showManualSuppOverride"
                  >
                    <label *ngIf="!loggedInAsServiceBuyer">CPI</label>
                    <label *ngIf="loggedInAsServiceBuyer">SCPI</label>
                  </th>
                  <th
                    class="feasibility"
                    data-name="feasibility"
                    [psUiSortTable]="cpi"
                  >
                    Feasibility
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let c of cpi; let $index = index; let $last = last">
                  <td>
                    <input
                      class="checkbox"
                      type="checkbox"
                      name="cpi"
                      [id]="c.id"
                      [checked]="c.selected"
                      (change)="itemChanged($event, c)"
                      [disabled]="!c.isActive"
                    />
                  </td>
                  <td>
                    <div class="form-check form-check-inline m-0 supp-checkbox">
                      <label class="form-check-label custom-check" [for]="c.id">
                        {{ c.supplier | slice : 0 : 40
                        }}{{ c.supplier.length <= 40 ? '' : '...' }}
                        <ps-ui-pds-label
                          *ngIf="c.isPdsApplied"
                          [supplierId]="c.id"
                          [cpi]="c.cpi"
                          [top]="$last"
                          [fee]="c.fee"
                        ></ps-ui-pds-label>
                      </label>
                    </div>
                  </td>

                  <td *ngIf="selectivePriceOveride || showManualSuppOverride">
                    <span (input)="validateManualOverrideRules($index)">
                      <span
                        class="currency-symbol"
                        [class.cpiBoxValue]="!manualSCPIOverrideEnabled"
                      >
                        {{ loggedInAsServiceBuyer ? '$' : currencySymbol }}
                      </span>
                      <input
                        *ngIf="!loggedInAsServiceBuyer"
                        type="number"
                        class="form-control"
                        (keypress)="numberOnly($event, true)"
                        (click)="selectInput($event)"
                        (blur)="formatCpi(c.cpi, $index)"
                        [ngModel]="c.cpi | number : '1.0-2'"
                        (ngModelChange)="c.cpi = $event"
                        [disabled]="
                          globalPriceOveride ||
                          isPurePriceApplied ||
                          !selectivePriceOveride ||
                          !c.selected
                        "
                        [ngClass]="{
                          cpiBoxValue: !selectivePriceOveride,
                          'input-error':
                            c.cpi > this.maxCpiThreshold &&
                            selectivePriceOveride
                        }"
                        psUiInputDecimalRestriction
                      />
                      <input
                        *ngIf="loggedInAsServiceBuyer && c.scpi !== undefined"
                        type="number"
                        class="form-control"
                        (keypress)="numberOnly($event, true)"
                        (click)="selectInput($event)"
                        (blur)="formatCpi(c.scpi, $index, true)"
                        [ngModel]="c.scpi | number : '1.0-2'"
                        (ngModelChange)="c.scpi = $event"
                        [disabled]="
                          isPurePriceApplied ||
                          !manualSCPIOverrideEnabled ||
                          !c.selected
                        "
                        [ngClass]="{
                          cpiBoxValue: !manualSCPIOverrideEnabled,
                          'input-error':
                            c.scpi > this.maxCpiThreshold &&
                            manualSCPIOverrideEnabled
                        }"
                        psUiInputDecimalRestriction
                      />
                    </span>
                  </td>
                  <td>
                    <div>
                      <span> {{ c.feasibility | zeroDash : '1.0-2' }} </span>
                      <div
                        class="setting-info feasibility-tooltip"
                        *ngIf="c.feasibility && c.unusedQualifications"
                      >
                        <i
                          class="fa fa-exclamation-triangle unused-qual-tooltip-icon"
                          aria-hidden="true"
                        ></i>
                        <p>
                          Unused Qualifications : {{ c.unusedQualifications }}
                        </p>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-template>
      </ps-ui-accordion-section>
    </ps-ui-accordion>
    <div class="row m-0 py-0 pt-3 px-5 justify-content-center">
      <button
        psUiButton
        color="secondary"
        size="small"
        [outline]="true"
        class="py-0 float-end button-text btn-default w-auto"
        (click)="openModal()"
        [disabled]="cpiRequireConfirmation"
        psUiGtagEvent
        trackOn="click"
        action="cpi"
        category="Black_Bar"
        [params]="{ event_label: 'CPI Modal' }"
      >
        Supplier allocation and details
      </button>
    </div>
  </ps-ui-dropdown>
  <div class="mb-0 cpi-container">
    <span
      *ngIf="!loading"
      class="header-div-span"
      [ngStyle]="{ color: headerCPI.isOpen ? 'black' : 'white' }"
    >
      {{ currencySymbol }}
      {{
        isMultiCountrySelected && !isDraftSaved
          ? (averageCPI | number : '1.2-2')
          : (totalCPI | number : '1.2-2')
      }}
    </span>
    <ps-ui-ellipsis-loader [show]="loading"> </ps-ui-ellipsis-loader>
  </div>
</div>
